import { BYTES_PER_GIB, BYTES_PER_MIB } from './constants';

// Redis holds a few mebibytes locally and several gibibytes in production;
// a fixed unit reads as "0.0 GiB" on one of the two.
export const formatBytes = (bytes: number): string =>
  bytes >= BYTES_PER_GIB
    ? `${(bytes / BYTES_PER_GIB).toFixed(1)} GiB`
    : `${Math.round(bytes / BYTES_PER_MIB)} MiB`;
